import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { departementService } from '../services/api';

const DepartementContext = createContext(null);

export function DepartementProvider({ children }) {
  const [departements, setDepartements]             = useState([]);
  const [selectedDepartement, setSelectedDepartement] = useState(null);
  const [loading, setLoading]                       = useState(true);

  const fetchDepartements = useCallback(() => {
    setLoading(true);
    return departementService.getAll()
      .then((res) => {
        const list = res.data?.result || [];
        setDepartements(list);
        // Keep current selection valid
        setSelectedDepartement((prev) => {
          if (!prev) return null;
          return list.find((d) => d.id === prev.id) || null;
        });
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { fetchDepartements(); }, [fetchDepartements]);

  return (
    <DepartementContext.Provider value={{
      departements,
      selectedDepartement,
      setSelectedDepartement,
      loadingDepartements: loading,
      refreshDepartements: fetchDepartements,
    }}>
      {children}
    </DepartementContext.Provider>
  );
}

export function useDepartement() {
  const ctx = useContext(DepartementContext);
  if (!ctx) throw new Error('useDepartement must be used inside DepartementProvider');
  return ctx;
}
